import React, { useState } from 'react';
import { 
  TextInput, 
  PasswordInput, 
  Button, 
  Paper, 
  Title, 
  Container, 
  Text, 
  Anchor,
  Stack,
  Alert
} from '@mantine/core';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';

/**
 * Register page component
 * Provides a form for users to create a new account
 */
const Register: React.FC = () => {
  // State to store form values
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [formError, setFormError] = useState('');
  
  // Get auth functions from context
  const { register, loading, error } = useAuth();

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormError('');
    
    // Basic validation
    if (password !== confirmPassword) {
      setFormError('Passwords do not match');
      return;
    }
    
    try {
      // Call register function from auth context
      await register(name, email, password);
      // Redirect is handled in the auth context
    } catch (err: any) {
      // Set form error if registration fails
      setFormError(err.response?.data?.message || 'Registration failed. Please try again.');
    }
  };

  return (
    <Layout hideNavigation>
      <Container size={420} my={40}>
        <Title ta="center">Create an account</Title>
        <Text c="dimmed" size="sm" ta="center" mt={5}>
          Already have an account?{' '}
          <Anchor component={Link} to="/login" size="sm">
            Sign in
          </Anchor>
        </Text>

        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
          <form onSubmit={handleSubmit}>
            <Stack>
              <TextInput
                label="Name"
                placeholder="Your name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <TextInput
                label="Email"
                placeholder="your@email.com"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <PasswordInput
                label="Password"
                placeholder="Your password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <PasswordInput
                label="Confirm Password"
                placeholder="Confirm your password"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              
              {/* Show error message if validation or registration fails */}
              {(formError || error) && (
                <Alert color="red" title="Error">
                  {formError || error}
                </Alert>
              )}
              
              <Button type="submit" loading={loading} fullWidth mt="xl">
                Create account
              </Button>
            </Stack>
          </form>
        </Paper>
      </Container>
    </Layout>
  );
};

export default Register; 